import React from "react";
import classes from "../memory.module.css";
import CustomModal from "../../../components/Modals/CustomModal";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { BASE, ERROR } from "../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../utils/constants/UI";
import Button from "../../../components/Buttons/Button";
import IconComponent from "../../../components/Icon/IconComponent";

const MemoryDeleteModal = ({ open, onClose, onConfirm, isDeleting }) => {
  return (
    <CustomModal
      width="30vw"
      blurBackdrop={true}
      open={open}
      onClose={onClose}
      header={{
        heading: { label: "Delete Knowledge" },
      }}
      footer={{
        right: (
          <div className={classes.actionButtons}>
            <Button
              label="Cancel"
              variant="ghost"
              size="sm36"
              onClick={onClose}
            />
            <Button
              label={isDeleting ? "Deleting..." : "Delete"}
              variant="primary"
              size="sm36"
              disabled={isDeleting}
              onClick={onConfirm}
            />
          </div>
        ),
      }}
    >
      <div className={classes.deleteModalBody}>
        <IconComponent
          iconLabel={ICON_LABELS.DELETE_OUTLINE}
          fontSize="64px"
          color={ERROR.W_500}
        />
        <TypographyInline
          label="Are you sure you want to delete this knowledge? This action cannot be undone."
          size="md"
          fontWeight={fontWeight.REGULAR}
          color={BASE.BLACK}
        />
      </div>
    </CustomModal>
  );
};

export default MemoryDeleteModal;
